<template>
  <div class="notfound-container">
    <div class="content-section content-container">
      <div class="bg-wrapper">
        <div class="notice-item">
          <p>{{ $t("404.t1") }}</p>
          <p>
            {{ $t("404.t2") }}
            <span class="time">{{ time }}</span>
            {{ $t("404.t3") }}
          </p>
        </div>
      </div>
    </div>
    <div class="blue-circle" />
    <div class="red-circle" />
    <div class="yellow-circle" />
    <div class="green-circle" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 0
    };
  },
  methods: {
    getTime() {
      const TIME_COUNT = 5;
      this.time = TIME_COUNT;
      let timer = setInterval(() => {
        if (this.time > 0 && this.time <= TIME_COUNT) {
          this.time--;
        } else {
          clearInterval(timer);
          timer = null;
          this.$router.push("/");
        }
      }, 1000);
    }
  },
  created() {
    this.getTime();
  }
};
</script>

<style lang="less" scoped>
.notfound-container {
  position: relative;
  padding-top: 64px;
  padding-bottom: 100px;
  width: 100%;
  .content-section {
    margin-top: 60px;
    position: relative;
    .bg-wrapper {
      height: 600px;
      max-width: 100%;
      margin-left: 88px;
      background: url("../../assets/404.png");
      background-size: contain;
      background-repeat: no-repeat;
      .notice-item {
        position: absolute;
        top: 30%;
        right: 25%;
        p {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(78, 90, 101, 1);
          line-height: 36px;
        }
        .time {
          color: #3f4ae1;
        }
      }
    }
  }
  .blue-circle {
    position: absolute;
    top: 102px;
    left: -38px;
    width: 108px;
    height: 108px;
    border-radius: 50%;
    background-color: #4b8bf6;
  }
  .yellow-circle {
    position: absolute;
    top: 69px;
    right: 10%;
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background-color: #f6b334;
  }
  .red-circle {
    position: absolute;
    top: 50%;
    left: 10%;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background-color: #e02053;
  }
  .green-circle {
    position: absolute;
    top: 50%;
    right: -100px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: #42c6ac;
  }
}
</style>
